/**
 * Acumulado desde el primer recuerdo; no depende del filtro (007 US1, FR-005)
 *
 * Con el icono de cada métrica (009, US2).
 */

import type { DashboardTotals } from '@/types/dashboard';
import { MetricIcon } from './MetricIcon';
import type { MetricKey } from './metricIcons';
import { formatNumber } from './format';

interface HistoricStripProps {
  totals: DashboardTotals;
}

function Row({ metric, label, value }: { metric: MetricKey; label: string; value: number }) {
  return (
    <div className="flex items-center gap-3">
      <MetricIcon metric={metric} size="sm" />
      <dt className="flex-1 text-xs font-light text-[#9d9c9c]">{label}</dt>
      <dd className="text-base font-normal tabular-nums text-[#1e1e1e]">{formatNumber(value)}</dd>
    </div>
  );
}

export function HistoricStrip({ totals }: HistoricStripProps) {
  const since = totals.first_memory_at
    ? new Date(totals.first_memory_at).toLocaleDateString('es-ES', { month: 'long', year: 'numeric' })
    : null;

  return (
    <section className="rounded-sm border border-gray-200 bg-[#f7f7f7] px-6 py-4" aria-labelledby="historic-title">
      <h2 id="historic-title" className="text-xs font-medium uppercase tracking-[0.5px] text-[#9d9c9c]">
        Desde que usas Kombu{since ? ` · ${since}` : ''}
      </h2>
      <dl className="mt-3 space-y-3">
        <Row metric="memories" label="Recuerdos" value={totals.memories} />
        <Row metric="views" label="Visualizaciones" value={totals.video_views} />
        <Row metric="clients" label="Clientes con nombre y correo" value={totals.clients} />
      </dl>
    </section>
  );
}
